module.exports = __webpack_public_path__ + "static/media/robots.18916bc0.txt";